export const PHONE_NUMBER = "02162995555"
export const PHONE_LINK = `tel:02162995555`

export const TELEGRAM = "https://t.me/tankhahgardan_com";
export const TELEGRAM_ADMIN = "https://t.me/TankhahgardanAdmin";
export const INSTAGRAM = "https://www.instagram.com/tankhahgardan";
export const WEBSITE = "https://tankhahgardan.com";
export const LINKEDIN = "https://linkedin.com/company/domusco";